import React from "react";

const PageStyle = ({ children }) => {
  return <div className="lg:px-24 px-2 w-screen h-screen">{children}</div>;
};

export default PageStyle;
